module.exports = __webpack_public_path__ + "static/media/Pay.ir.3e6d6cea.svg";